import { colors } from '../../styles/colors';
import { LabelVariant } from './Label';

export const getLabelStyle = (variant?: LabelVariant, isActive?: boolean) => {
  if (isActive) {
    switch (variant) {
      case LabelVariant.primary:
        return {
          color: colors.alertPrimaryColor,
          backgroundColor: colors.alertPrimaryBackgroundColor,
        };
      case LabelVariant.info:
        return {
          color: colors.alertInfoColorHover,
          backgroundColor: colors.alertInfoBackgroundColorHover,
        };
      case LabelVariant.success:
        return {
          color: colors.alertSuccessColorHover,
          backgroundColor: colors.alertSuccessBackgroundColorHover,
        };
      case LabelVariant.warning:
        return {
          color: colors.alertWarningColorHover,
          backgroundColor: colors.alertWarningBackgroundColorHover,
        };
      case LabelVariant.warning_secondary:
        return {
          color: colors.alertWarningSecondaryColorHover,
          backgroundColor: colors.alertWarningSecondaryBackgroundColorHover,
        };
      case LabelVariant.error:
        return {
          color: colors.alertErrorColorHover,
          backgroundColor: colors.alertErrorBackgroundColorHover,
        };
      case LabelVariant.secondary:
        return {
          color: colors.alertSecondaryColorHover,
          backgroundColor: colors.alertSecondaryBackgroundColorHover,
        };
      case LabelVariant.disabled:
        return {
          color: colors.alertPrimaryColor,
          backgroundColor: colors.disabledColor,
        };
      default:
        return undefined;
    }
  }

  switch (variant) {
    case LabelVariant.primary:
      return {
        color: colors.alertPrimaryColor,
        backgroundColor: colors.alertPrimaryBackgroundColor,
      };
    case LabelVariant.info:
      return {
        color: colors.alertInfoColor,
        backgroundColor: colors.alertInfoBackgroundColor,
      };
    case LabelVariant.success:
      return {
        color: colors.alertSuccessColor,
        backgroundColor: colors.alertSuccessBackgroundColor,
      };
    case LabelVariant.warning:
      return {
        color: colors.alertWarningColor,
        backgroundColor: colors.alertWarningBackgroundColor,
      };
    case LabelVariant.warning_secondary:
      return {
        color: colors.alertWarningSecondaryColor,
        backgroundColor: colors.alertWarningSecondaryBackgroundColor,
      };
    case LabelVariant.error:
      return {
        color: colors.alertErrorColor,
        backgroundColor: colors.alertErrorBackgroundColor,
      };
    case LabelVariant.secondary:
      return {
        color: colors.alertSecondaryColor,
        backgroundColor: colors.alertSecondaryBackgroundColor,
      };
    case LabelVariant.disabled:
      return {
        color: colors.alertPrimaryColor,
        backgroundColor: colors.disabledColor,
      };
    default:
      return undefined;
  }
};
